import React, { useState } from 'react';
import postIcon from './postIcon.png';
import getIcon from './getIcon.png';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ResponsiveTableContainer = ({ children }) => (
    <div style={{ overflowX: 'auto', width: '100%' }}>
        {children}
    </div>
);


const Info8 = () => {
    const [openResponse, setOpenResponse] = useState(null);

    const toggleResponse = (code) => {
        setOpenResponse(openResponse === code ? null : code);
    };

    return (
        <div style={{
            fontFamily: 'Gilroy-Light',
            lineHeight: 1.6,
            overflowX: 'auto',
            width: '100%',
            maxWidth: '100vw',  // ekranın genişliğini aşmasın
            boxSizing: 'border-box',
            padding: '0px 16px',
        }}>

            <h2 style={{ marginTop: 0 }}><strong>Authorization Code Flow:</strong></h2>

            <p>
                Authorization Code Flow, like the password flow, is an authorization mechanism used as part of the OAuth 2.0 protocol. Specifically designed for web applications, this flow requires user authentication before granting access permission to the application. Once users log in to the application, retrieves an authorization code, which can then be used to obtain an access token. </p>
            <p>
                In order to use private APIs you can get an Access Token by Authorization Code Flow.
                This type of flow requires a customer login.
                (also see <a href="https://tools.ietf.org/html/rfc6749" target="_blank" rel="noopener noreferrer">RFC-6749</a>)
            </p>


            <p>In this flow, you can obtain the token in two steps:</p>

            <h3><strong>1. Request for Authorization</strong></h3>
            <p>To obtain authorization, a GET request needs to be made to the Albaraka Auth Server from the browser.  The request must contain client_id, response_type, scope, state and redirect_uri information. The request redirects customer to login page. After customer review scope informations its going to let to use, enters login credentials or deny login process.
                At the login part, test username and password are used for test users and In the step where the sms password is obtained, test password can be entered.
            </p>
            <p>The required Get request address is as follows;</p>

            <ul>
                <li>
                    <img src={getIcon} alt="GET" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For test environment:</strong><br />
                    <code>https://testomnichannellogin.albarakaturk.com.tr/</code>
                </li>
                <li style={{ marginTop: '10px' }}>
                    <img src={getIcon} alt="GET" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For production environment:</strong><br />
                    <code>https://omnichannellogin.albaraka.com.tr/</code>
                </li>
            </ul>

            <h4><strong>Request Parameters:</strong></h4>
            <ResponsiveTableContainer>
                <Table sx={{ minWidth: '100%', width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Required</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell>client_id</StyledTableCell>
                            <StyledTableCell>The client id provided to you when you create new application</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>response_type</StyledTableCell>
                            <StyledTableCell>It is crucial for determining the type of token or code that will be obtained in the response. The value must be Code (see OAuth 2.0 spec)</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>scope</StyledTableCell>
                            <StyledTableCell>The group that includes the APIs you want to authorize. Please verify which scopes were activated during the application creation process. Ensure that your selection is made from the activated scopes.</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>state</StyledTableCell>
                            <StyledTableCell>This parameter will be passed to redirect uri</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>false</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>redirect_uri</StyledTableCell>
                            <StyledTableCell>The URI to redirect after the user grants/denies permission. Ensure that the 'redirect_url' matches the url you entered when creating your application.</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </ResponsiveTableContainer>

            <h4><strong>Sample Request:</strong></h4>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {`https://testomnichannellogin.albarakaturk.com.tr/?response_type=code&
client_id=api-portal&state=635af1bf85314e0da40312163ab47725&scope=accounts,loans
&redirect_uri=http://mywebsite.com`}</pre>
            <p>After user grants (or denies) access, Albaraka Auth Server redirects user to "redirect_uri" that provided in first request.
                If the user has granted access, an authorization code will be provided. This code will be used to take an access token in next step.</p>
            <h4><strong>Redirecting contains following data:</strong></h4>

            <ResponsiveTableContainer>
                <Table sx={{ minWidth: '100%', width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell>code</StyledTableCell>
                            <StyledTableCell>The code in order to take access token if user granted</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>state</StyledTableCell>
                            <StyledTableCell>The data if optionally passed in first request</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>error</StyledTableCell>
                            <StyledTableCell>Error code occured while authorization of the user</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </ResponsiveTableContainer>

            <h4><strong>Sample redirected uri:</strong></h4>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {`http://mywebsite.com?code=12345&state=635af1bf85314e0da40312163ab47725`}</pre>
            <p>or</p>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {`http://mywebsite.com?error=access_denied&state=635af1bf85314e0da40312163ab47725`}</pre>

            <h3><strong>2. Take Access Token</strong></h3>
            <p>This is the final step of the authorization process. If you have been successful in the previous step, you can obtain the Access Token with the 'authorization code.' A POST request should be made to the Albaraka Auth Server.</p>
            <p>The required Post request address is as follows;</p>

            <ul>
                <li>
                    <img src={postIcon} alt="POST" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For test environment:</strong><br />
                    <code>https://apitest.albarakaturk.com.tr/ocf-auth-server/auth/oauth/token</code>
                </li>
                <li style={{ marginTop: '10px' }}>
                    <img src={postIcon} alt="POST" style={{ width: '32px', verticalAlign: 'middle', marginRight: '8px' }} />
                    <strong>For production environment:</strong><br />
                    <code>https://api.albarakaturk.com.tr/ocf-auth-server/auth/oauth/token</code>
                </li>
            </ul>

            <h3><strong>Request</strong></h3>
            <p>
                The authorization type should be selected as basic authentication. In the basic Auth, the Authorization header transmits a Base64-encoded string,
                representing your client_id and client_secret values, to the API.
            </p>

            <h4><strong>Request Body Parameters</strong></h4>
            <p>Content-Type: <code>x-www-form-urlencoded</code></p>
            <ResponsiveTableContainer>
                <Table sx={{ minWidth: '100%', width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                            <StyledTableCell style={{ fontSize: 16 }}>Required</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <StyledTableRow>
                            <StyledTableCell>grant_type</StyledTableCell>
                            <StyledTableCell>A parameter in the OAuth 2.0 protocol indicating the type of authorization requested by a client. The value should be authorization_code</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>code</StyledTableCell>
                            <StyledTableCell>The Authorization Code provided in first step</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>redirect_uri</StyledTableCell>
                            <StyledTableCell>The URI to redirect after the user grants/denies permission. Ensure that the 'redirect_url' matches the url you entered when creating your application.</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>false</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>state</StyledTableCell>
                            <StyledTableCell>This parameter will be passed to redirect uri</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>false</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow>
                            <StyledTableCell>corporateUsername</StyledTableCell>
                            <StyledTableCell>User code given to your company's authorized officers. It should only be used for corporate accounts.</StyledTableCell>
                            <StyledTableCell>string</StyledTableCell>
                            <StyledTableCell>true</StyledTableCell>
                        </StyledTableRow>
                    </TableBody>
                </Table>
            </ResponsiveTableContainer>

            <h4><strong>Sample Request:</strong></h4>
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {`POST /ocf-auth-server/auth/oauth/token HTTP/1.1
Host: apitest.albarakaturk.com.tr
Authorization: Basic cjViNnN3Zm5zbWcybGJ1ODNzNHByamU0bHlvd2k1Mmc6Z0lNUU9zYlN6T1FucDJwJEBvSWNseD1nWlVuaUckSUtlWmdrcS5DcVFFY0BRSVRWSjNlWko0V0dobnhjOThWMg==
Content-Type: application/x-www-form-urlencoded
Content-Length: 89

code=187057638610031645921552017147671482721919777361355527&grant_type=authorization_code&redirect_uri=https%3A%2F%2Fwww.albaraka.com.tr%2F
`}</pre>
            <h3><strong>Responses</strong></h3>
            {[200, 400, 401, 500].map((code) => {
                const isOpen = openResponse === code;
                let title = '', content = null;

                if (code === 200) {
                    title = '200 OK';
                    content = (
                        <>  <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: '100%', width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Access_token</StyledTableCell>
                                            <StyledTableCell>An authorized token to call Albaraka public or analytic APIs</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Token_type</StyledTableCell>
                                            <StyledTableCell>Always "bearer"</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Refresh_token</StyledTableCell>
                                            <StyledTableCell>Refresh_token	The token contains the information required to obtain a new Access Token</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Expires_in</StyledTableCell>
                                            <StyledTableCell>Expiration time of access_token (seconds)</StyledTableCell>
                                            <StyledTableCell>integer</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Scope</StyledTableCell>
                                            <StyledTableCell>Authorized scope of Access Token</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Sample:</h3>
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"access_token": "925b75c8-99a7-48f1-ad5a-618c54fbc07d",
"token_type": "bearer",
"refresh_token": "2f5e3e3f-7dd8-44b7-b6ac-30802f3d8cb2",
"expires_in": 599,
"scope": "public accounts"
}`}</pre></>
                    );
                } else if (code === 400) {
                    title = '400 Bad Request';
                    content = (
                        <>  <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: '100%', width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Error</StyledTableCell>
                                            <StyledTableCell>Description of the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Error_description</StyledTableCell>
                                            <StyledTableCell>Detailed information about the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Samples:</h3>
                            <p>Entering the grant_type information is mandatory. If the grant type information is not provided, the error returned is:</p>
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"error": "invalid_request",
"error_description": "Missing grant type"
}`}</pre>
                            <p>Entering the code information is mandatory. If the code information is not provided, the error returned is:</p>
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"error": "invalid_request",
"error_description": "An authorization code must be supplied."
}`}</pre>

                            <p>When making a request, it is not necessary to include the redirect_url parameter. However, if it is provided, ensure that the value is entered correctly. If the redirect URL is incorrectly specified, an error similar to the following will be returned:</p>
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"error": "invalid_grant",
"error_description": "Redirect URI mismatch."
}`}</pre>
                        </>
                    );
                } else if (code === 401) {
                    title = '401 Unauthorized';
                    content = (
                        <>  <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: '100%', width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Error</StyledTableCell>
                                            <StyledTableCell>Description of the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Error_description</StyledTableCell>
                                            <StyledTableCell>Detailed information about the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Samples:</h3>
                            <p>The error received when the client ID, client secret, or access URL is missing or incorrectly added is:</p>

                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"error": "unauthorized",
"error_description": "Full authentication is required to access this resource"
}`}</pre>

                        </>
                    );
                } else if (code === 500) {
                    title = '500 Internal Server Error';
                    content = (
                        <>  <br /><h5><strong>Parameters:</strong></h5><br />
                            <ResponsiveTableContainer>
                                <Table sx={{ minWidth: '100%', width: '100%' }}>
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell style={{ fontSize: 16 }}>Name</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Definition</StyledTableCell>
                                            <StyledTableCell style={{ fontSize: 16 }}>Type</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>Error</StyledTableCell>
                                            <StyledTableCell>Description of the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow>
                                            <StyledTableCell>Error_description</StyledTableCell>
                                            <StyledTableCell>Detailed information about the error received</StyledTableCell>
                                            <StyledTableCell>string</StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            </ResponsiveTableContainer>
                            <h3>Samples:</h3>
                            <p>This status code indicates an unexpected error occurred on the server while processing the request. It's a generic error message that doesn't provide specific details about the issue.</p>
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                                {`{
"error": "server_error",
"error_description": "Internal Server Error"
}`}</pre>
                        </>
                    );
                }

                return (
                    <div key={code} style={{ background: '#f9f9f9', padding: '10px', marginBottom: '10px' }}>
                        <div
                            onClick={() => toggleResponse(code)}
                            style={{ cursor: 'pointer', fontWeight: 'bold', display: 'flex', justifyContent: 'space-between' }}
                        >
                            <span>{title}</span>
                            <span>{isOpen ? '▲' : '▼'}</span>
                        </div>
                        {isOpen && <div style={{ marginTop: '10px' }}>{content}</div>}
                    </div>
                );
            })}
        </div>
    );
};

export default Info8;